import React from 'react'
import { Button, Col, Form, Select } from 'antd';
import map from "lodash/map";
import find from "lodash/find";
import get from "lodash/get";

import { getButtonDisabled } from '../../utilities/helpers';

const HeaderSelector = ({ filter, setFilters, config, getCompanyStaff, setSelectedCompany, setStaff, staffs, form }) => {
  return (
    <>
      <Col xs={24} md={6}>
        <Form.Item
          name="Company"
          label="Company"
          colon={false}
          layout="vertical"
        >
          <Select
            style={{ minWidth: 250 }}
            size="middle"
            placeholder="Select Company"
            options={map(get(config, "companies"), (company) => ({
              label: get(company, "name"),
              value: get(company, "id"),
            }))}
            optionFilterProp="label"
            showSearch
            onChange={(val) => {
              setSelectedCompany(val);
              const company = find(get(config, "companies"), [
                "id",
                val,
              ]);
              setFilters({
                ...filter,
                company,
              });
              form.setFieldsValue({ fileType: undefined, fileList: undefined })
              setStaff({ ...staffs, data: [], filtered: [], filters: { searchQuery: undefined, role: undefined }, isLoaded: false })
            }}
          />
        </Form.Item>
      </Col>
      <Col xs={24} md={6}>
        <Form.Item
          name="submit"
          label=" "
          colon={false}
          layout="vertical"
        >
          <Button
            type="primary"
            className="w-30"
            onClick={getCompanyStaff}
            disabled={getButtonDisabled(filter, ["company"])}
          >
            Submit
          </Button>
        </Form.Item>
      </Col>
    </>
  )
}

export default HeaderSelector